import React, { useEffect, useCallback, useState} from 'react';
import BPMComponent from "components/toolbar/BPMComponent.js";
import SynthzEffects from './SynthzEffects.js';
import EditorBottom from "components/v3/editor/EditorBottom.js";
import {
    savePreset,
} from 'components/v2/trackRightClickActions.js';
import {
    setPresetSaved,
    setSelectedZObject} from 'actions/index.js';
import Packs from './Packs.js';
import Modals from "components/v2/Modals.js";
import GuildsMenu from "components/guilds/GuildsMenu.js";
import ZObjectComponent from "components/zobject/ZObjectComponent.js";
import AuditionSidebar from "components/v3/sidebar/audition/AuditionSidebar.js";
import {useSynthz} from './useSynthz.js';
import {connect} from 'react-redux';
import {useSequencer} from "components/v2/useSequencer.js";
import {useKeyListener} from "components/v2/useKeyListener.js";
import RackSynthComponent from "components/instruments/RackSynthComponent.js";
import '../v3/sidebar/sidebar.scss';
import './synthz.scss';
import '../v3/v3.scss';
import '../v3/pianoroll.scss';
import '../v3/colors.scss';
import '../../App.css';
import '../../QuickAdd.scss';
import '../../Sidebar.scss';
import '../../Installation.scss';
import '../../SynthBrowser.scss';
import '../../zobject.scss';
import '../../Sequences.css';
import '../../DrumMachineImportMode.css';
import '../../Groups.scss';
import '../../subpatch.scss';
import '../v3/mobile.scss';
import '../../Packs.scss';
import '../../animation.css';
import '../../Preferences.css';
import '../../colors.scss';
import '../../Guilds.scss';
import '../../Explore2.scss';
import '../../Cirklon.scss';
import '../../Common.css';
//import '../v3/sidebar/.css';
import '../../NFT.scss';
import 'react-dropdown/style.css';
import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap-slider/dist/css/bootstrap-slider.css";


const SynthPage = (props) => { 
    let [isCollapsed, setIsCollapsed] = useState(true);
    let [ethereumCache, sequencerEngine, ethereumSearcher] = props.sequencerEngine ? [undefined, sequencerEngine, undefined] :
    useSequencer(props);
    if (props.sequencerEngine) {
        sequencerEngine = props.sequencerEngine;
    }
    window.synthz = true;
    let [keyListener] = useKeyListener({sequencerEngine: sequencerEngine});
    const [saving, setSaving] = useState(false);
    const [save, setSave] = useState(undefined);

    let {track, canvasBackground, oscilloscope} =  useSynthz(sequencerEngine);

    const onClickSave = useCallback(() => {
        if (track) {
            props.setSelectedZObject(track);
            setSaving(true);
            savePreset(track);
        }
    }, [track, setSaving]);

    useEffect(() => {
        if (props.presetSaved && save) {
            setTimeout(() => {
                save.fn(props.presetSaved);
                props.setPresetSaved(undefined);
            }, 2000);
        }
    }, [props.presetSaved, save]);

    useEffect(() => {
        window.addEventListener("keydown", startUp);
        return () => window.removeEventListener("keydown", startUp);
    }, [sequencerEngine]);

    const startUp = useCallback(() => {
        if (sequencerEngine && !sequencerEngine.playing) {
            sequencerEngine.schedulePlay();
        }
    }, [sequencerEngine]);

    return (
        <div
          onClick={startUp}
          className="v3 synthz no-select dark">
          <Modals sequencerEngine={sequencerEngine} store={props.store}/>
          <GuildsMenu store={props.store}/>
          {sequencerEngine && track && <Packs setSave={setSave} track={track} sequencerEngine={sequencerEngine}/>}
          {<img className="pushable save-preset-icon" onClick={() => onClickSave()} src="/save-preset-floppy.svg"/>}
          {track && <RackSynthComponent
                      sequencerEngine={sequencerEngine}
                      track={track} instrument={track.instrument}/>}

          {/*track && <ZObjectComponent zobject={sequencerEngine.currentSubSequence.zObjects[2]}/>*/}
          <div className="oscilloscope-wrapper">
            {oscilloscope && <ZObjectComponent forceShow={true} zobject={oscilloscope}/>}
          </div>
          {sequencerEngine && <BPMComponent sequencerEngine={sequencerEngine}/>}
          <div className="canvas-wrapper">
            {canvasBackground && <ZObjectComponent zobject={canvasBackground}/>}
          </div>
          {track && <SynthzEffects track={track}/>}
          <div className="editor-and-sidebars">
            <div className={isCollapsed ? "right sidebar collapsed" : "right sidebar Audition"}>
              <div className="collapse-header">
                <div
                  onClick={() => setIsCollapsed(!isCollapsed)}
                  className="pushable arrow-container">
                  <div className={isCollapsed ? "collapsed-arrow" : "uncollapsed-arrow"}/>
                </div>
              </div>
            {!isCollapsed && track && 
             <AuditionSidebar object={track} sequencerEngine={sequencerEngine}/>}
          </div>
          </div>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
      presetSaved: state.presets.presetSaved
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setPresetSaved: x => dispatch(setPresetSaved(x)),
      setSelectedZObject: x => dispatch(setSelectedZObject(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SynthPage);
